import { Directive, Input } from '@angular/core';
import { TranslateService } from './translate.service';
import * as i0 from "@angular/core";
import * as i1 from "./translate.service";
export class TranslateDirective {
    constructor(elementRef, render, translateService) {
        this.elementRef = elementRef;
        this.render = render;
        this.translateService = translateService;
    }
    set translate(key) {
        const phrase = this.translateService.translate(key);
        if (phrase) {
            this.render.setProperty(this.elementRef.nativeElement, 'innerHTML', phrase);
        }
    }
}
TranslateDirective.ɵfac = function TranslateDirective_Factory(t) { return new (t || TranslateDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i1.TranslateService)); };
TranslateDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: TranslateDirective, selectors: [["", "mheTranslate", ""]], inputs: { translate: "translate" }, features: [i0.ɵɵProvidersFeature([TranslateService])] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TranslateDirective, [{
        type: Directive,
        args: [{
                selector: '[mheTranslate]',
                providers: [TranslateService],
            }]
    }], function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i1.TranslateService }]; }, { translate: [{
            type: Input
        }] }); })();
